import { render, staticRenderFns } from "./Countries.vue?vue&type=template&id=670642ae&scoped=true&"
import script from "./Countries.vue?vue&type=script&lang=js&"
export * from "./Countries.vue?vue&type=script&lang=js&"
import style0 from "./Countries.vue?vue&type=style&index=0&id=670642ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670642ae",
  null
  
)

export default component.exports